import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { NominalShipping } from '../../../../../typings'
import styles from '../styles'
import { ReviewProps } from './constants'
import { messages } from './messages'

type Props = ReviewProps & {
  config: NominalShipping
}

export function NominalShippingReview(props: Props) {
  const { config } = props
  const { formatCurrency } = useNumbers()

  return (
    <SummaryRow.Value className={styles.flexRow}>
      <FormattedMessage
        {...messages.nominalShipping}
        values={{
          tag: (content) => <Tag>{content}</Tag>,
          b: (content) => <Text variant="body">{content}</Text>,
          discount: formatCurrency(config.value),
        }}
      />
    </SummaryRow.Value>
  )
}
